import React, { useCallback, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { Alert } from "antd";
import { i18nUtil } from "@aspen/libs";
import { PagePortalLogin } from "@aspen/pages";

/** 登录页置顶：只看地址栏是否有 redirectFromAspen（与老站 301 联调） */
function LoginMigrationBanner(): React.ReactElement | null {
  const router = useRouter();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const v = new URLSearchParams(window.location.search).get("redirectFromAspen");
    setVisible(v === "1" || v === "true");
  }, [router.asPath]);

  const onClose = useCallback(() => {
    const u = new URL(window.location.href);
    u.searchParams.delete("redirectFromAspen");
    const nextUrl = `${u.pathname}${u.search}${u.hash}`;
    void router.replace(nextUrl, undefined, { shallow: true });
    setVisible(false);
  }, [router]);

  if (!visible) return null;

  const intl = i18nUtil.t();

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        insetInlineStart: 0,
        zIndex: 1050,
        width: "100%",
        pointerEvents: "auto",
      }}>
      <Alert
        showIcon
        type="info"
        closable
        onClose={onClose}
        message={intl["sunset.redirect.notice.title"]}
        description={
          <span dangerouslySetInnerHTML={{ __html: intl["sunset.redirect.notice.desc"] }} />
        }
      />
    </div>
  );
}

export default function Login(): React.ReactElement {
  return (
    <>
      <LoginMigrationBanner />
      <PagePortalLogin />
    </>
  );
}
